<div class="dialog">

  <h1 mat-dialog-title>Element Details</h1>

  <div class="details-body">
    <div class="empty" *ngIf="candidates.length === 0">No locator candidates were captured for this element.</div>

    <div class="details-table" *ngIf="candidates.length > 0">
      <div class="candidate-row" *ngFor="let c of candidates">
        <div class="candidate-label" [title]="c.label">{{ c.label || '—' }}</div>
        <div class="candidate-value" [title]="c.value">{{ c.value }}</div>
      </div>
    </div>
  </div>

  <div class="ftbtn-gr" mat-dialog-actions>
    <button class="ftbtn" mat-button (click)="onClose()">Close</button>
  </div>
</div>
